import { createContext, useContext } from 'react'
import { siteWhatsAppMessage } from '../siteDestinations'

/**
 * O que os componentes compartilhados (botão flutuante, rodapé) precisam saber
 * da página atual. Fica separado do registro para não criar importação circular
 * (o registro importa as páginas, que importam esses componentes).
 */
export type PageContextValue = {
  path: string
  whatsappMessage: string
}

export const PageContext = createContext<PageContextValue>({
  path: '/',
  whatsappMessage: siteWhatsAppMessage,
})

export const usePage = () => useContext(PageContext)
